export default "__VITE_ASSET__vlQ5KuQ8__"